import React, { createContext, useContext, useEffect } from 'react'
import { ThemeConfig, getCurrentTheme } from '@/lib/themes'

interface ThemeStyleContextType {
  theme: ThemeConfig
}

const ThemeStyleContext = createContext<ThemeStyleContextType | undefined>(undefined)

export function useThemeStyle() {
  const context = useContext(ThemeStyleContext)
  if (!context) {
    throw new Error('useThemeStyle must be used within a ThemeStyleProvider')
  }
  return context
}

interface ThemeStyleProviderProps {
  children: React.ReactNode
}

export function ThemeStyleProvider({ children }: ThemeStyleProviderProps) {
  const theme = getCurrentTheme()

  useEffect(() => {
    // Aplica as variáveis CSS customizadas do tema
    const root = document.documentElement
    
    // Border radius
    root.style.setProperty('--theme-radius-sm', theme.styles.borderRadius.sm)
    root.style.setProperty('--theme-radius-md', theme.styles.borderRadius.md)
    root.style.setProperty('--theme-radius-lg', theme.styles.borderRadius.lg)
    root.style.setProperty('--theme-radius-xl', theme.styles.borderRadius.xl)
    
    // Spacing
    root.style.setProperty('--theme-spacing-section', theme.styles.spacing.section)
    root.style.setProperty('--theme-spacing-container', theme.styles.spacing.container)
    root.style.setProperty('--theme-spacing-card', theme.styles.spacing.card)
    
    // Typography
    root.style.setProperty('--theme-font-family', theme.styles.typography.fontFamily)
    root.style.setProperty('--theme-heading-weight', theme.styles.typography.headingWeight)
    root.style.setProperty('--theme-body-weight', theme.styles.typography.bodyWeight)
    
    // Effects
    root.style.setProperty('--theme-shadow', theme.styles.effects.shadow)
    root.style.setProperty('--theme-blur', theme.styles.effects.blur)
    root.style.setProperty('--theme-gradient', theme.styles.effects.gradient)
    
    // Animation
    root.style.setProperty('--theme-duration', theme.styles.animation.duration)
    root.style.setProperty('--theme-easing', theme.styles.animation.easing)
    
    // Components
    root.style.setProperty('--theme-card-padding', theme.components.card.padding)
    root.style.setProperty('--theme-navbar-height', theme.components.navbar.height)
    
  }, [theme])

  return (
    <ThemeStyleContext.Provider value={{ theme }}>
      {children}
    </ThemeStyleContext.Provider>
  )
}